// extracted by mini-css-extract-plugin
export default {"documentItem":"DocListForDownload_documentItem__GiyAO"};